import moize from "moize";
import debounce from "debounce-promise";

const autocompleteService =
  window.google && new window.google.maps.places.AutocompleteService();

const baseGetSuggestions = value => {
  if (!autocompleteService || !value || value === "")
    return Promise.resolve([]);

  return new Promise(resolve => {
    const req = { input: value };

    autocompleteService.getPlacePredictions(req, (predictions, status) => {
      if (status !== window.google.maps.places.PlacesServiceStatus.OK) {
        resolve([]);
      } else {
        resolve(predictions);
      }
    });
  });
};

const cachedGetSuggestions = moize(baseGetSuggestions, {
  isPromise: true,
  maxAge: 60000
});

const debouncedAndCachedGetSuggestions = debounce(cachedGetSuggestions, 250);

const getSuggestions = debouncedAndCachedGetSuggestions;

const geocoder = new window.google.maps.Geocoder();

const getSuggestionGeocode = suggestion =>
  new Promise((resolve, reject) => {
    if (!window.google) return Promise.resolve();

    geocoder.geocode({ placeId: suggestion.place_id }, (results, status) => {
      if (status !== window.google.maps.GeocoderStatus.OK) {
        reject(
          new Error(
            `Geocoding query for a place with an ID of '${suggestion.place_id}' failed - response status: ${status}`
          )
        );

        return;
      }

      resolve(results);
    });
  });

export { getSuggestions, getSuggestionGeocode };
